import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';
import {
  loading,
  newCampaign,
  fetchCampaigns,
  activateCampaign,
  deleteCampaign,
} from './actions';

export const initialState = {
  loading: false,
  campaigns: [], // all campaigns
};

export const reducer = handleActions(
  {
    [loading]: {
      next: state =>
        update(state, {
          loading: { $set: true },
        }),
    },

    [newCampaign]: {
      next: state =>
        update(state, {
          loading: { $set: false },
          status: { $set: 'creating' },
          selectedId: { $set: null },
        }),
    },

    [fetchCampaigns]: {
      next: (state, { payload: { docs: payload } }) => {
        return update(state, {
          loading: { $set: false },
          campaigns: { $set: payload || [] },
          selectedId: { $set: null },
        });
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          campaigns: { $set: [] },
          selectedId: { $set: null },
        });
      },
    },

    [activateCampaign]: {
      next: (state, { payload }) => {
        const index = state.campaigns.map(el => el._id).indexOf(payload._id);
        if (index >= 0) {
          return update(state, {
            loading: { $set: false },
            campaigns: { [index]: { active: { $set: payload.active } } },
          });
        }
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },

    [deleteCampaign]: {
      next: (state, { payload }) => {
        const index = state.campaigns.map(el => el._id).indexOf(payload._id);
        if (index >= 0) {
          // Delete
          state = update(state, {
            loading: { $set: false },
            campaigns: { $splice: [[index, 1]] },
          });
          return state;
        }
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
